import { CorrectionsRequest, CorrectionsResponse } from './Correction.types';
import api from '@/api';
import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/invoices`;

export async function listCorrections(invoiceId: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${invoiceId}/cce`,
    null,
  )) as unknown;

  return result as CorrectionsResponse[];
}

export async function listCorrectionId(invoiceId: number, cceId: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${invoiceId}/cce${cceId}`,
    null,
  )) as unknown;

  return result as CorrectionsResponse;
}

export async function createCorrection(obj: CorrectionsRequest) {
  const { invoiceId, ...restObject } = obj;

  const result = (await api.post(
    `${CONTROLLER_URL}/${invoiceId}/cce`,
    restObject,
    null,
  )) as unknown;

  return result as CorrectionsResponse;
}

export async function updateCorrection(obj: CorrectionsRequest) {
  const { invoiceId, cceId, ...restObject } = obj;

  const result = (await api.put(
    `${CONTROLLER_URL}/${invoiceId}/cce/${cceId}`,
    restObject,
    null,
  )) as unknown;

  return result as CorrectionsResponse;
}

export async function deleteCorrection(invoiceId: number, cceId: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${invoiceId}/cce/${cceId}`,
    {},
    null,
  )) as unknown;

  return result as CorrectionsResponse;
}
